import { useLocalStorage } from 'usehooks-ts'

export const OPERATIONS_SOUND_STORAGE_KEY = 'notificationSound.operationsEnabled'

export const useOperationsSoundPreference = () => useLocalStorage(OPERATIONS_SOUND_STORAGE_KEY, true)
